import React from 'react';
import { Link } from 'react-router-dom';
import Page from './Page';

const ForAuthorsPage = () => (
  <Page eyebrow="A NOTE TO WRITERS" title="For Authors">
    <p className="legal-pull">
      Your book changed lives. iCraftz makes sure it changes more.
    </p>
    <p>
      We structure your book's core wisdom into:
    </p>
    <ul>
      <li>A powerful summary</li>
      <li>Key insights readers can remember</li>
      <li>Action items they can apply today</li>
      <li>A core theme that stays with them forever</li>
    </ul>
    <p>
      All delivered in 10 languages to readers who may never have found your
      book otherwise.
    </p>
    <p>
      We would love your endorsement, your partnership or simply your blessing.
    </p>
    <div style={{ marginTop: '32px' }}>
      <Link to="/partner" className="legal-cta-btn" data-testid="for-authors-partner-link">
        Partner with Us →
      </Link>
    </div>
  </Page>
);

export default ForAuthorsPage;
